import { createAuthLink, AUTH_TYPE, AuthOptions } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";

import {
  ApolloClient,
  createHttpLink,
  ApolloLink,
  InMemoryCache,
} from "@apollo/client/core";

const env = {} as any;
const url =
  "https://bhbrbai3c5dplognjits4p2xsu.appsync-api.eu-central-1.amazonaws.com/graphql";
const region = "eu-central-1";

interface GraphQLClientConfig {
  accessKeyId: string;
  secretAccessKey: string;
}

export const getGraphqlClient = (conf: GraphQLClientConfig) => {
  const auth = {
    type: AUTH_TYPE.AWS_IAM,
    credentials: {
      accessKeyId: conf.accessKeyId,
      secretAccessKey: conf.secretAccessKey,
      // accessKeyId: "AKIASDCGF3GMUCJYOFV5",
      // secretAccessKey: "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",
      // sessionToken: env.REACT_APP_AWS_SESSION_TOKEN,
    },
  } as AuthOptions;
  const httpLink = createHttpLink({ uri: url });

  const link = ApolloLink.from([
    createAuthLink({ url, region, auth }),
    createSubscriptionHandshakeLink({ url, region, auth }, httpLink),
  ]);

  return new ApolloClient({
    link,
    // uri: url,
    cache: new InMemoryCache(),
  });
};
